module.exports = __webpack_public_path__ + "img/table_cells.726bf0a0.svg";